import config from 'config'

export const headerWithCredentials = {credentials: 'include', headers: {'Content-Type': 'application/json'}}

export const ruleServerUrl = config.ruleServerUrl



// WEBPACK FOOTER //
// ./src/configs/rule-server.js